import ProfileTags from '@/components/user/ProfileTags'
import vSelect from 'vue-select'
import VButton from '@/components/shared/VButton'

export default {
  name: 'TagSelectBloc',
  components: { VButton, ProfileTags, vSelect },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    userTags: {
      type: Array,
      default: () => []
    },
    actionLabel: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    editable: Boolean,
    allowNewValues: {
      type: Boolean,
      default: true
    },
    onSelect: {
      type: Function,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      selectingTags: false
    }
  },
  methods: {
    reset() {
      this.selectingTags = false
    },
    browseTags() {
      this.selectingTags = true
    },
    getSimilarTag(list, tag) {
      return list.find(element => {
        if (element.name) {
          return element.name.trim().toUpperCase() === tag.name.trim().toUpperCase()
        }
        return null
      })
    },
    addTag(selected) {
      if (selected.length === 0) {
        return
      }
      this.reset()
      if (!selected.id) {
        // Check if user already have similar tag (same letters, different case)
        if (this.getSimilarTag(this.userTags, selected)) {
          return
        }
        // Check if there is already a similar tag in the list
        selected = this.getSimilarTag(this.availableTags, selected) || selected
      }
      this.onSelect(selected)
    },
    removeTag(tag) {
      this.onDelete(tag)
    }
  },
  computed: {
    availableTags() {
      const userTagIds = this.userTags.map(tag => tag.id)
      return this.tags.filter(tag => userTagIds.indexOf(tag.id) < 0)
    }
  }
}
